const initialState = {
    filtersData: [],
    carbonFiltersData: [],
    cigaretteData: [],
    carbonCigaretteData: [],
    plugwrapData: [],
    epdData: []
};

const filtersReducer = (state = initialState, action) => {
    if (action.type === 'FILTERS_DATA') {
		if(action.filtersData && action.filtersData.length) {
			action.filtersData.forEach(function(obj) {
				if(obj.isShared) {
                    if(obj.displayName && obj.displayName.indexOf('(Shared by') >= 0) {
                        var regex = / \(Shared by (.*)\)/;
                        var matches = obj.displayName.match(regex);
                        obj.displayName = obj.displayName.replace(matches[1], obj.sharedBy.firstName + ' ' + obj.sharedBy.lastName);
                    } else {
                        obj.displayName = ' (Shared by ' + obj.sharedBy.firstName + ' ' + obj.sharedBy.lastName + ')';
                    }
                } else {
                    obj.displayName = '';
                }
                return obj;
			});
		}
		return Object.assign({}, state, {
            filtersData: action.filtersData
		});
    }
    if (action.type === 'CARBON_FILTERS_DATA') {
		if(action.carbonFiltersData && action.carbonFiltersData.length) {
			action.carbonFiltersData.forEach(function(obj) {
				if(obj.isShared) {
					if(obj.displayName && obj.displayName.indexOf('(Shared by') >= 0) {
						var regex = / \(Shared by (.*)\)/;
						var matches = obj.displayName.match(regex);
						obj.displayName = obj.displayName.replace(matches[1], obj.sharedBy.firstName + ' ' + obj.sharedBy.lastName);
					} else {
						obj.displayName = ' (Shared by ' + obj.sharedBy.firstName + ' ' + obj.sharedBy.lastName + ')';
					}
				} else {
                    obj.displayName = '';
                }
                return obj;
			});
		}
		return Object.assign({}, state, {
            carbonFiltersData: action.carbonFiltersData
		});
    }
    if (action.type === 'CIGARETTE_DATA') {
		if(action.cigaretteData && action.cigaretteData.length) {
			action.cigaretteData.forEach(function(obj) {
				if(obj.isShared) {
                    if(obj.displayName && obj.displayName.indexOf('(Shared by') >= 0) {
                        var regex = / \(Shared by (.*)\)/;
                        var matches = obj.displayName.match(regex);
                        obj.displayName = obj.displayName.replace(matches[1], obj.sharedBy.firstName + ' ' + obj.sharedBy.lastName);
                    } else {
                        obj.displayName = ' (Shared by ' + obj.sharedBy.firstName + ' ' + obj.sharedBy.lastName + ')';
                    }
                } else {
                    obj.displayName = '';
                }
                return obj;
			});
		}
		return Object.assign({}, state, {
            cigaretteData: action.cigaretteData
		});
    }
    if (action.type === 'CARBON_CIGARETTE_DATA') {
		if(action.carbonCigaretteData && action.carbonCigaretteData.length) {
			action.carbonCigaretteData.forEach(function(obj) {
				if(obj.isShared) {
                    if(obj.displayName && obj.displayName.indexOf('(Shared by') >= 0) {
                        var regex = / \(Shared by (.*)\)/;
                        var matches = obj.displayName.match(regex);
                        obj.displayName = obj.displayName.replace(matches[1], obj.sharedBy.firstName + ' ' + obj.sharedBy.lastName);
                    } else {
                        obj.displayName = ' (Shared by ' + obj.sharedBy.firstName + ' ' + obj.sharedBy.lastName + ')';
                    }
                } else {
                    obj.displayName = '';
                }
                return obj;
			});
		}
		return Object.assign({}, state, {
            carbonCigaretteData: action.carbonCigaretteData
		});
    }
    if (action.type === 'PLUGWRAP_DATA') {
		return Object.assign({}, state, {
            plugwrapData: action.plugwrapData
		});
    }
    if (action.type === 'EPD_DATA') {
		return Object.assign({}, state, {
            epdData: action.epdData
		});
    }
    return state;
};

export default filtersReducer;


// WEBPACK FOOTER //
// ./src/reducers/filtersReducer.js